const createFocusTrap = require('focus-trap');

export default function rlxNavigation() {
    const $nav = $('.js-rlx-v7-header');
    const $menuOpenButton = $nav.find('.item__toggle--default');
    const $menuCloseButton = $nav.find('.item__toggle--open');
    const $menu = $nav.find('.nav__list--menu');
    const openClassMenu = 'nav__list--open';
    const isHidden = 'is--hidden';


    const focusTrapRlxMenu = createFocusTrap('.nav__list--menu', {
        clickOutsideDeactivates: true,
    });

    const closeMenu = () => {
        $menuOpenButton.removeClass(isHidden);
        $menuCloseButton.addClass(isHidden);
        $menu.removeClass(openClassMenu);
        focusTrapRlxMenu.deactivate();
    };

    $menuCloseButton.on('click touch', (e) => {
        const $this = $(e.currentTarget);
        event.preventDefault();
        $this.addClass(isHidden);
        closeMenu();
    });

    $('.close--menu').on('click', () => {
        closeMenu();
    });

    $menuOpenButton.on('click touch', (e) => {
        const $this = $(e.currentTarget);
        event.preventDefault();
        $menuCloseButton.removeClass(isHidden);
        $this.addClass(isHidden);

        $menu.addClass(openClassMenu);
        focusTrapRlxMenu.activate();
    });
}
